import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { removeAnnouncement, removeError, removeInformation, removeWarning } from '../actions/errors';
import { announce } from '../utils/announce';

import * as error from './Error.module.css';
import { default as Icon } from './Icon';

/** Soft warnings stay up longer than errors — they are informational and easy to miss. */
const WARNING_TIMEOUT_MS = 10000;

class Error extends PureComponent {
    componentDidUpdate(prevProps) {
        if (!prevProps.error && this.props.error) {
            announce(this.props.error, 'assertive');
            if (document.getElementById('main')) {
                document.getElementById('main').scrollTop = 0;
            }
            setTimeout(() => this.props.onRemoveError(), 5000);
        } else if (!prevProps.information && this.props.information) {
            announce(this.props.information, 'polite');
            if (document.getElementById('main')) {
                document.getElementById('main').scrollTop = 0;
            }
            setTimeout(() => this.props.onRemoveInformation(), 5000);
        }
        if (!prevProps.warning && this.props.warning) {
            announce(this.props.warning, 'polite');
            if (document.getElementById('main')) {
                document.getElementById('main').scrollTop = 0;
            }
            clearTimeout(this.warningTimeout);
            this.warningTimeout = setTimeout(() => this.props.onRemoveWarning(), WARNING_TIMEOUT_MS);
        }
        if (!prevProps.announcement && this.props.announcement) {
            announce(this.props.announcement, 'polite');
        }
    }

    componentWillUnmount() {
        clearTimeout(this.warningTimeout);
    }

    handleRemoveAnnouncement = () => {
        this.props.onRemoveAnnouncement();
    };

    handleRemoveError = () => {
        this.props.onRemoveError();
    };

    handleRemoveInformation = () => {
        this.props.onRemoveInformation();
    };

    handleRemoveWarning = () => {
        clearTimeout(this.warningTimeout);
        this.props.onRemoveWarning();
    };

    render() {
        if (!this.props.error && !this.props.information && !this.props.announcement && !this.props.warning) {
            return null;
        }

        return (
            <>
                {this.props.announcement && (
                    <div className={error.errorBox}>
                        <div className={error.errorContent}>
                            <div className={error.announcementContent}>
                                <div className={error.errorMessage}>{this.props.announcement}</div>
                                <div className={error.errorSubMessage}>{this.props.announcementPeriod}</div>
                            </div>
                            <button
                                aria-label="Lukk melding"
                                className={error.removeButton}
                                onClick={this.handleRemoveAnnouncement}
                            >
                                <Icon className={error.removeIcon} type={'kryss'} />
                            </button>
                        </div>
                    </div>
                )}
                {this.props.error && (
                    <div className={error.errorBox}>
                        <div className={error.errorContent}>
                            <div className={error.errorMessage}>{this.props.error}</div>
                            <button
                                aria-label="Lukk feil"
                                className={error.removeButton}
                                onClick={this.handleRemoveError}
                            >
                                <Icon className={error.removeIcon} type={'kryss'} />
                            </button>
                        </div>
                    </div>
                )}
                {this.props.information && (
                    <div className={error.informationBox}>
                        <div className={error.errorContent}>
                            <div className={error.errorMessage}>{this.props.information}</div>
                            <button
                                aria-label="Lukk informasjon"
                                className={error.removeButton}
                                onClick={this.handleRemoveInformation}
                            >
                                <Icon className={error.removeIcon} type={'kryss'} />
                            </button>
                        </div>
                    </div>
                )}
                {this.props.warning && (
                    <div className={error.warningBox}>
                        <div className={error.errorContent}>
                            <div className={error.errorMessage}>{this.props.warning}</div>
                            <button
                                aria-label="Lukk advarsel"
                                className={error.removeButton}
                                onClick={this.handleRemoveWarning}
                            >
                                <Icon className={error.removeIcon} type={'kryss'} />
                            </button>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

Error.propTypes = {
    announcement: PropTypes.string,
    announcementPeriod: PropTypes.string,
    error: PropTypes.string,
    information: PropTypes.string,
    onRemoveAnnouncement: PropTypes.func.isRequired,
    onRemoveError: PropTypes.func.isRequired,
    onRemoveInformation: PropTypes.func.isRequired,
    onRemoveWarning: PropTypes.func.isRequired,
    warning: PropTypes.string,
};

const mapStateToProps = ({ errors }) => ({
    announcement: errors.announcement,
    announcementPeriod: errors.announcementPeriod,
    error: errors.error,
    information: errors.information,
    warning: errors.warning,
});

const mapDispatchToProps = (dispatch) => ({
    onRemoveAnnouncement: () => {
        dispatch(removeAnnouncement());
    },
    onRemoveError: () => {
        dispatch(removeError());
    },
    onRemoveInformation: () => {
        dispatch(removeInformation());
    },
    onRemoveWarning: () => {
        dispatch(removeWarning());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Error);
